import { render, staticRenderFns } from "./specificActDetail.vue?vue&type=template&id=1172e90d&scoped=true"
import script from "./specificActDetail.vue?vue&type=script&lang=js"
export * from "./specificActDetail.vue?vue&type=script&lang=js"
import style0 from "./specificActDetail.vue?vue&type=style&index=0&id=1172e90d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172e90d",
  null
  
)

export default component.exports